import { render, staticRenderFns } from "./indexView.vue?vue&type=template&id=6c7b22b5"
import script from "./indexView.vue?vue&type=script&lang=js"
export * from "./indexView.vue?vue&type=script&lang=js"
import style0 from "./indexView.vue?vue&type=style&index=0&id=6c7b22b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports